const currency = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR'
})

/**
 * Format number to Euro currency
 * @param {Number} value Value to format
 * @returns {String} Formatted value
 */
export default function (value) {
  if (!value || typeof value !== 'number') {
    return value
  }

  return currency.format(value)
}
